export default __webpack_public_path__ + "static/media/Rewards features.fb2a56ba.jpg";